// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../node_modules/@fontsource/open-sans/600.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../node_modules/@fontsource/open-sans/700.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../node_modules/material-icons/iconfont/filled.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../node_modules/@fontsource/open-sans/files/open-sans-cyrillic-ext-400-normal.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../node_modules/@fontsource/open-sans/files/open-sans-all-400-normal.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../node_modules/@fontsource/open-sans/files/open-sans-cyrillic-400-normal.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../node_modules/@fontsource/open-sans/files/open-sans-greek-ext-400-normal.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../node_modules/@fontsource/open-sans/files/open-sans-greek-400-normal.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../node_modules/@fontsource/open-sans/files/open-sans-hebrew-400-normal.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../node_modules/@fontsource/open-sans/files/open-sans-vietnamese-400-normal.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../node_modules/@fontsource/open-sans/files/open-sans-latin-ext-400-normal.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../../node_modules/@fontsource/open-sans/files/open-sans-latin-400-normal.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../../node_modules/@cw/icons/src/fonts/cw-icon.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../../node_modules/@cw/icons/src/fonts/cw-icon.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../../node_modules/@cw/icons/src/fonts/cw-icon.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../../../node_modules/@cw/icons/src/fonts/cw-icon.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../../../node_modules/@cw/icons/src/fonts/cw-icon.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* open-sans-cyrillic-ext-400-normal*/
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-display: swap;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;
}
/* open-sans-cyrillic-400-normal*/
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-display: swap;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
  unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
}
/* open-sans-greek-ext-400-normal*/
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-display: swap;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
  unicode-range: U+1F00-1FFF;
}
/* open-sans-greek-400-normal*/
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-display: swap;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
  unicode-range: U+0370-03FF;
}
/* open-sans-hebrew-400-normal*/
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-display: swap;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
  unicode-range: U+0590-05FF, U+200C-2010, U+20AA, U+25CC, U+FB1D-FB4F;
}
/* open-sans-vietnamese-400-normal*/
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-display: swap;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
  unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;
}
/* open-sans-latin-ext-400-normal*/
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-display: swap;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* open-sans-latin-400-normal*/
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-display: swap;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/*--------------------------------

cw-icon icon font
Generated using nucleoapp.com

-------------------------------- */
@font-face {
  font-family: 'cw-icon';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('embedded-opentype'), url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('truetype'), url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('svg');
}
/* base class */
.cw-icon {
  display: inline-block;
  font: normal normal normal 1em/1 'cw-icon';
  color: inherit;
  flex-shrink: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
/* size examples - relative units */
.cw-icon-sm {
  font-size: 0.8em;
}
.cw-icon-lg {
  font-size: 1.2em;
}
/* size examples - absolute units */
.cw-icon-16 {
  font-size: 16px;
}
.cw-icon-32 {
  font-size: 32px;
}
/* rotate the icon infinitely */
.cw-icon-is-spinning {
  animation: cw-icon-spin 1s infinite linear;
}
@keyframes cw-icon-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/* transform */
.cw-icon-rotate-90 {
  transform: rotate(90deg);
}
.cw-icon-rotate-180 {
  transform: rotate(180deg);
}
.cw-icon-rotate-270 {
  transform: rotate(270deg);
}
.cw-icon-flip-y {
  transform: scaleY(-1);
}
.cw-icon-flip-x {
  transform: scaleX(-1);
}
/* icons */
.cw-icon-map-pin::before {
  content: "\\ea18";
}
.cw-icon-hierarchy::before {
  content: "\\ea19";
}
.cw-icon-input-arrow-up::before {
  content: "\\ea1a";
}
.cw-icon-import::before {
  content: "\\ea1b";
}
.cw-icon-full-screen-exit::before {
  content: "\\ea1c";
}
.cw-icon-drag::before {
  content: "\\ea1d";
}
.cw-icon-cost-details::before {
  content: "\\ea1e";
}
.cw-icon-undo::before {
  content: "\\ea1f";
}
.cw-icon-redo::before {
  content: "\\ea20";
}
.cw-icon-pin::before {
  content: "\\ea21";
}
.cw-icon-map-stack::before {
  content: "\\ea22";
}
.cw-icon-input-plus::before {
  content: "\\ea23";
}
.cw-icon-input-minus::before {
  content: "\\ea24";
}
.cw-icon-input-calendar::before {
  content: "\\ea25";
}
.cw-icon-hide-map-pin::before {
  content: "\\ea26";
}
.cw-icon-input-arrow-down::before {
  content: "\\ea27";
}
.cw-icon-collapse-all::before {
  content: "\\ea28";
}
.cw-icon-calendar::before {
  content: "\\ea29";
}
.cw-icon-swap::before {
  content: "\\ea2a";
}
.cw-icon-utility::before {
  content: "\\ea2b";
}
.cw-icon-world::before {
  content: "\\ea2c";
}
.cw-icon-work-order::before {
  content: "\\ea2d";
}
.cw-icon-audit::before {
  content: "\\ea2e";
}
.cw-icon-arrow-right::before {
  content: "\\ea2f";
}
.cw-icon-web::before {
  content: "\\ea30";
}
.cw-icon-water::before {
  content: "\\ea31";
}
.cw-icon-waive::before {
  content: "\\ea32";
}
.cw-icon-wait::before {
  content: "\\ea33";
}
.cw-icon-info::before {
  content: "\\ea34";
}
.cw-icon-user::before {
  content: "\\ea35";
}
.cw-icon-user-female::before {
  content: "\\ea36";
}
.cw-icon-unflag::before {
  content: "\\ea37";
}
.cw-icon-unfavorite::before {
  content: "\\ea38";
}
.cw-icon-tv::before {
  content: "\\ea39";
}
.cw-icon-transportation::before {
  content: "\\ea3a";
}
.cw-icon-transfer::before {
  content: "\\ea3b";
}
.cw-icon-traffic-light::before {
  content: "\\ea3c";
}
.cw-icon-timer::before {
  content: "\\ea3d";
}
.cw-icon-time::before {
  content: "\\ea3e";
}
.cw-icon-task::before {
  content: "\\ea3f";
}
.cw-icon-tag::before {
  content: "\\ea40";
}
.cw-icon-table::before {
  content: "\\ea41";
}
.cw-icon-supplier::before {
  content: "\\ea42";
}
.cw-icon-strategy::before {
  content: "\\ea43";
}
.cw-icon-storeroom::before {
  content: "\\ea44";
}
.cw-icon-split-screen::before {
  content: "\\ea45";
}
.cw-icon-sort-descending::before {
  content: "\\ea46";
}
.cw-icon-sort-ascending::before {
  content: "\\ea47";
}
.cw-icon-show::before {
  content: "\\ea48";
}
.cw-icon-shock::before {
  content: "\\ea49";
}
.cw-icon-settings::before {
  content: "\\ea4a";
}
.cw-icon-service-request::before {
  content: "\\ea4b";
}
.cw-icon-send::before {
  content: "\\ea4c";
}
.cw-icon-secure::before {
  content: "\\ea4d";
}
.cw-icon-search::before {
  content: "\\ea4e";
}
.cw-icon-scan::before {
  content: "\\ea4f";
}
.cw-icon-save::before {
  content: "\\ea50";
}
.cw-icon-rows::before {
  content: "\\ea51";
}
.cw-icon-roadwork::before {
  content: "\\ea52";
}
.cw-icon-reset::before {
  content: "\\ea53";
}
.cw-icon-requisition::before {
  content: "\\ea54";
}
.cw-icon-recent::before {
  content: "\\ea55";
}
.cw-icon-receive::before {
  content: "\\ea56";
}
.cw-icon-project::before {
  content: "\\ea57";
}
.cw-icon-power::before {
  content: "\\ea58";
}
.cw-icon-pll::before {
  content: "\\ea59";
}
.cw-icon-pinpoint::before {
  content: "\\ea5a";
}
.cw-icon-phone::before {
  content: "\\ea5b";
}
.cw-icon-percent::before {
  content: "\\ea5c";
}
.cw-icon-payment::before {
  content: "\\ea5d";
}
.cw-icon-park::before {
  content: "\\ea5e";
}
.cw-icon-pan::before {
  content: "\\ea5f";
}
.cw-icon-open::before {
  content: "\\ea60";
}
.cw-icon-notification::before {
  content: "\\ea61";
}
.cw-icon-next::before {
  content: "\\ea62";
}
.cw-icon-navigate::before {
  content: "\\ea63";
}
.cw-icon-mobile::before {
  content: "\\ea64";
}
.cw-icon-minimize::before {
  content: "\\ea65";
}
.cw-icon-microphone::before {
  content: "\\ea66";
}
.cw-icon-menu::before {
  content: "\\ea67";
}
.cw-icon-material::before {
  content: "\\ea68";
}
.cw-icon-map::before {
  content: "\\ea69";
}
.cw-icon-maintenance::before {
  content: "\\ea6a";
}
.cw-icon-mail::before {
  content: "\\ea6b";
}
.cw-icon-mail-open::before {
  content: "\\ea6c";
}
.cw-icon-love::before {
  content: "\\ea6d";
}
.cw-icon-logout::before {
  content: "\\ea6e";
}
.cw-icon-lock::before {
  content: "\\ea6f";
}
.cw-icon-link::before {
  content: "\\ea70";
}
.cw-icon-like::before {
  content: "\\ea71";
}
.cw-icon-layers::before {
  content: "\\ea72";
}
.cw-icon-issue::before {
  content: "\\ea73";
}
.cw-icon-invert::before {
  content: "\\ea74";
}
.cw-icon-inspection::before {
  content: "\\ea75";
}
.cw-icon-apps::before {
  content: "\\ea76";
}
.cw-icon-image::before {
  content: "\\ea77";
}
.cw-icon-idea::before {
  content: "\\ea78";
}
.cw-icon-hydrant::before {
  content: "\\ea79";
}
.cw-icon-html::before {
  content: "\\ea7a";
}
.cw-icon-home::before {
  content: "\\ea7b";
}
.cw-icon-hide::before {
  content: "\\ea7c";
}
.cw-icon-hide-map::before {
  content: "\\ea7d";
}
.cw-icon-help::before {
  content: "\\ea7e";
}
.cw-icon-group::before {
  content: "\\ea7f";
}
.cw-icon-funnel::before {
  content: "\\ea80";
}
.cw-icon-full-screen::before {
  content: "\\ea81";
}
.cw-icon-cctv::before {
  content: "\\ea82";
}
.cw-icon-configure::before {
  content: "\\ea83";
}
.cw-icon-flag::before {
  content: "\\ea84";
}
.cw-icon-budget::before {
  content: "\\ea85";
}
.cw-icon-filter::before {
  content: "\\ea86";
}
.cw-icon-file-video::before {
  content: "\\ea87";
}
.cw-icon-file-txt::before {
  content: "\\ea88";
}
.cw-icon-file-pdf::before {
  content: "\\ea89";
}
.cw-icon-file-doc::before {
  content: "\\ea8a";
}
.cw-icon-file-csv::before {
  content: "\\ea8b";
}
.cw-icon-file-blank::before {
  content: "\\ea8c";
}
.cw-icon-fee::before {
  content: "\\ea8d";
}
.cw-icon-favorite::before {
  content: "\\ea8e";
}
.cw-icon-export::before {
  content: "\\ea8f";
}
.cw-icon-expand-up::before {
  content: "\\ea90";
}
.cw-icon-expand-right::before {
  content: "\\ea91";
}
.cw-icon-expand-panel::before {
  content: "\\ea92";
}
.cw-icon-expand-left::before {
  content: "\\ea93";
}
.cw-icon-expand-down::before {
  content: "\\ea94";
}
.cw-icon-expand-all::before {
  content: "\\ea95";
}
.cw-icon-estimate::before {
  content: "\\ea96";
}
.cw-icon-erase::before {
  content: "\\ea97";
}
.cw-icon-ellipsis-vertical::before {
  content: "\\ea98";
}
.cw-icon-ellipsis-horizontal::before {
  content: "\\ea99";
}
.cw-icon-edit::before {
  content: "\\ea9a";
}
.cw-icon-edit-circle::before {
  content: "\\ea9b";
}
.cw-icon-duration::before {
  content: "\\ea9c";
}
.cw-icon-drop::before {
  content: "\\ea9d";
}
.cw-icon-drag-up::before {
  content: "\\ea9e";
}
.cw-icon-drag-right::before {
  content: "\\ea9f";
}
.cw-icon-drag-left::before {
  content: "\\eaa0";
}
.cw-icon-drag-down::before {
  content: "\\eaa1";
}
.cw-icon-delete::before {
  content: "\\eaa2";
}
.cw-icon-dashboard::before {
  content: "\\eaa3";
}
.cw-icon-customize::before {
  content: "\\eaa4";
}
.cw-icon-counter::before {
  content: "\\eaa5";
}
.cw-icon-construction::before {
  content: "\\eaa6";
}
.cw-icon-chart-line::before {
  content: "\\eaa7";
}
.cw-icon-complete::before {
  content: "\\eaa8";
}
.cw-icon-compass::before {
  content: "\\eaa9";
}
.cw-icon-comment::before {
  content: "\\eaaa";
}
.cw-icon-columns::before {
  content: "\\eaab";
}
.cw-icon-collapse::before {
  content: "\\eaac";
}
.cw-icon-cloud::before {
  content: "\\eaad";
}
.cw-icon-close::before {
  content: "\\eaae";
}
.cw-icon-close-circle::before {
  content: "\\eaaf";
}
.cw-icon-clone::before {
  content: "\\eab0";
}
.cw-icon-clone-circle::before {
  content: "\\eab1";
}
.cw-icon-check-circle::before {
  content: "\\eab2";
}
.cw-icon-chart-spline::before {
  content: "\\eab3";
}
.cw-icon-chart-pie::before {
  content: "\\eab4";
}
.cw-icon-add::before {
  content: "\\eab5";
}
.cw-icon-chart-curve::before {
  content: "\\eab6";
}
.cw-icon-chart-column::before {
  content: "\\eab7";
}
.cw-icon-chart-bar::before {
  content: "\\eab8";
}
.cw-icon-center-on-map::before {
  content: "\\eab9";
}
.cw-icon-bug::before {
  content: "\\eaba";
}
.cw-icon-caution::before {
  content: "\\eabb";
}
.cw-icon-case::before {
  content: "\\eabc";
}
.cw-icon-cancel::before {
  content: "\\eabd";
}
.cw-icon-calculator::before {
  content: "\\eabe";
}
.cw-icon-arrow-left::before {
  content: "\\eabf";
}
.cw-icon-add-circle::before {
  content: "\\eac0";
}
.cw-icon-bookmark::before {
  content: "\\eac1";
}
.cw-icon-barcode::before {
  content: "\\eac2";
}
.cw-icon-auto::before {
  content: "\\eac3";
}
.cw-icon-arrow-up::before {
  content: "\\eac4";
}
.cw-icon-audio::before {
  content: "\\eac5";
}
.cw-icon-attach::before {
  content: "\\eac6";
}
.cw-icon-asset::before {
  content: "\\eac7";
}
.cw-icon-assembly::before {
  content: "\\eac8";
}
.cw-icon-ask::before {
  content: "\\eac9";
}
.cw-icon-arrow-down::before {
  content: "\\eaca";
}
.cw-icon-abc::before {
  content: "\\eacb";
}
.cw-icon-search-circle::before {
  content: "\\ead0";
}
.cw-icon-preview::before {
  content: "\\ead1";
}
.cw-icon-collapse-panel::before {
  content: "\\ead9";
}
.cw-icon-text-underline::before {
  content: "\\eada";
}
.cw-icon-text-strikethrough::before {
  content: "\\eadd";
}
.cw-icon-text-italic::before {
  content: "\\eade";
}
.cw-icon-text-bold::before {
  content: "\\eadf";
}
.cw-icon-list-number::before {
  content: "\\eae0";
}
.cw-icon-list-bullet::before {
  content: "\\eae1";
}
.cw-icon-at::before {
  content: "\\eae2";
}
.cw-icon-text-superscript::before {
  content: "\\eae3";
}
.cw-icon-text-subscript::before {
  content: "\\eae4";
}
.cw-icon-file-shp::before {
  content: "\\eae6";
}
.cw-icon-expand-all-panels::before {
  content: "\\eae8";
}
.cw-icon-collapse-all-panels::before {
  content: "\\eaea";
}
.cw-icon-uncheck-all::before {
  content: "\\eaeb";
}
.cw-icon-check-all::before {
  content: "\\eaec";
}
.cw-icon-portal::before {
  content: "\\eaed";
}
.cw-icon-menu-page::before {
  content: "\\eaee";
}
.cw-icon-split-screen-collapse::before {
  content: "\\eaef";
}
.cw-icon-cityworks-logo::before {
  content: "\\eaf0";
}
.cw-icon-download::before {
  content: "\\eaf1";
}
.cw-icon-watch::before {
  content: "\\eaf2";
}
.cw-icon-not-watching::before {
  content: "\\eaf3";
}
.cw-icon-review::before {
  content: "\\eaf4";
}
.cw-icon-hearing::before {
  content: "\\eaf5";
}
.cw-icon-last::before {
  content: "\\eaf6";
}
.cw-icon-first::before {
  content: "\\eaf7";
}
.cw-icon-host::before {
  content: "\\eaf8";
}
.cw-icon-upload::before {
  content: "\\eaf9";
}
.cw-icon-task-group::before {
  content: "\\eafa";
}
.cw-icon-split-screen-swap-sides::before {
  content: "\\eafb";
}
.cw-icon-split-screen-expand-right::before {
  content: "\\eafc";
}
.cw-icon-split-screen-expand-left::before {
  content: "\\eafd";
}
.cw-icon-notification-add::before {
  content: "\\eafe";
}
.cw-icon-previous::before {
  content: "\\eaff";
}
.cw-icon-filter-table::before {
  content: "\\eb00";
}
.cw-icon-agol::before {
  content: "\\eb01";
}
/* --------------------------------
Font face definition simplified to only include woff2
-------------------------------- */
@font-face {
  font-family: 'cw-icon';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('woff2');
  font-weight: normal;
  font-style: normal;
}
:root {
  --bgColor_appBar: var(--cw-color-back-primary);
  --fgColor_spinner: #2e78ac;
  --height_topAppBar: 60px;
  --cw-color-primary: #217cbb;
  --cw-color-text-primary: #252a2e;
  --cw-color-text-secondary: rgba(37, 42, 46, 0.7);
  --cw-color-text-hint: rgba(37, 42, 46, 0.5);
  --cw-color-back-primary: #fff;
  --cw-color-back-blue: #dcedf9;
  --cw-color-divider-primary: rgba(37, 42, 46, 0.65);
  --cw-color-divider-secondary: rgba(37, 42, 46, 0.15);
  --cwui-color-palette-warn: #da212c;
}
:root .btn.btn-primary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #0063a3;
  --bs-btn-border-color: #0063a3;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0082d6;
  --bs-btn-hover-border-color: #0082d6;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #00548a;
  --bs-btn-active-border-color: #00548a;
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #0063a3;
  --bs-btn-disabled-border-color: #0063a3;
}
:root .btn.btn-light {
  --bs-btn-color: #252a2e;
}
:root .card {
  --bs-card-bg: var(--cw-color-back-primary);
}
:root .navbar {
  --bs-navbar-padding-x: 16px;
  --bs-navbar-padding-y: 2.25px;
}
html,
body,
#root {
  position: relative;
  margin: 0;
  padding: 0;
  min-block-size: 100%;
  block-size: 100%;
  font-family: 'Open Sans', sans-serif;
}
.RootShell {
  position: relative;
  block-size: 100%;
}
button {
  cursor: pointer;
}
button.btn[type="button"] {
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: flex-start;
  align-items: center;
}
a:not(.btn, .dropdown-item):visited,
a:not(.btn, .dropdown-item):active {
  color: #217cbb;
}
a:not(.btn, .dropdown-item):hover,
a:not(.btn, .dropdown-item):focus-visible {
  color: #0063a3;
}
.cw-icon {
  font-size: 18px;
  padding: 3px;
}
`, "",{"version":3,"sources":["webpack://./projects/shared/src/global.less","webpack://./node_modules/@fontsource/open-sans/index.css","webpack://./node_modules/@cw/icons/src/less/icons.less","webpack://./node_modules/@cw/icons/src/_cw-material-icon-woff2.less","webpack://./projects/shared/src/global-vars.less"],"names":[],"mappings":"AAAA,qCAAqC;ACCrC;EACE,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oHAAA;EACA,sFAAA;ADKF;AACA,iCAAiC;ACHjC;EACE,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oHAAA;EACA,oEAAA;ADKF;AACA,kCAAkC;ACHlC;EACE,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oHAAA;EACA,0BAAA;ADKF;AACA,8BAA8B;ACH9B;EACE,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oHAAA;EACA,0BAAA;ADKF;AACA,+BAA+B;ACH/B;EACE,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oHAAA;EACA,oEAAA;ADKF;AACA,mCAAmC;ACHnC;EACE,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oHAAA;EACA,gHAAA;ADKF;AACA,kCAAkC;ACHlC;EACE,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oHAAA;EACA,mHAAA;ADKF;AACA,8BAA8B;ACH9B;EACE,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oHAAA;EACA,yKAAA;ADKF;AACA;;;;;kCAKkC;AExElC;EACE,sBAAA;EACA,4CAAA;EACA,gTAAA;AF0EF;AACA,eAAe;AEnEf;EACE,qBAAA;EACA,0CAAA;EACA,cAAA;EACA,cAAA;EACA,mCAAA;EACA,kCAAA;AFqEF;AACA,mCAAmC;AElEnC;EACC,gBAAA;AFoED;AEjEA;EACE,gBAAA;AFmEF;AACA,mCAAmC;AEhEnC;EACE,eAAA;AFkEF;AE/DA;EACE,eAAA;AFiEF;AACA,+BAA+B;AE9D/B;EACE,0CAAA;AFgEF;AE7DA;EACE;IACE,uBAAA;EF+DF;EE7DA;IACE,yBAAA;EF+DF;AACF;AACA,cAAc;AE5Dd;EACC,wBAAA;AF8DD;AE3DA;EACC,yBAAA;AF6DD;AE1DA;EACC,yBAAA;AF4DD;AEzDA;EACC,qBAAA;AF2DD;AExDA;EACC,qBAAA;AF0DD;AACA,UAAU;AEoKV;EACE,gBAAA;AFlKF;AEqKA;EACE,gBAAA;AFnKF;AEsKA;EACE,gBAAA;AFpKF;AEuKA;EACE,gBAAA;AFrKF;AEwKA;EACE,gBAAA;AFtKF;AEyKA;EACE,gBAAA;AFvKF;AE0KA;EACE,gBAAA;AFxKF;AE2KA;EACE,gBAAA;AFzKF;AE4KA;EACE,gBAAA;AF1KF;AE6KA;EACE,gBAAA;AF3KF;AE8KA;EACE,gBAAA;AF5KF;AE+KA;EACE,gBAAA;AF7KF;AEgLA;EACE,gBAAA;AF9KF;AEiLA;EACE,gBAAA;AF/KF;AEkLA;EACE,gBAAA;AFhLF;AEmLA;EACE,gBAAA;AFjLF;AEoLA;EACE,gBAAA;AFlLF;AEqLA;EACE,gBAAA;AFnLF;AEsLA;EACE,gBAAA;AFpLF;AEuLA;EACE,gBAAA;AFrLF;AEwLA;EACE,gBAAA;AFtLF;AEyLA;EACE,gBAAA;AFvLF;AE0LA;EACE,gBAAA;AFxLF;AE2LA;EACE,gBAAA;AFzLF;AE4LA;EACE,gBAAA;AF1LF;AE6LA;EACE,gBAAA;AF3LF;AE8LA;EACE,gBAAA;AF5LF;AE+LA;EACE,gBAAA;AF7LF;AEgMA;EACE,gBAAA;AF9LF;AEiMA;EACE,gBAAA;AF/LF;AEkMA;EACE,gBAAA;AFhMF;AEmMA;EACE,gBAAA;AFjMF;AEoMA;EACE,gBAAA;AFlMF;AEqMA;EACE,gBAAA;AFnMF;AEsMA;EACE,gBAAA;AFpMF;AEuMA;EACE,gBAAA;AFrMF;AEwMA;EACE,gBAAA;AFtMF;AEyMA;EACE,gBAAA;AFvMF;AE0MA;EACE,gBAAA;AFxMF;AE2MA;EACE,gBAAA;AFzMF;AE4MA;EACE,gBAAA;AF1MF;AE6MA;EACE,gBAAA;AF3MF;AE8MA;EACE,gBAAA;AF5MF;AE+MA;EACE,gBAAA;AF7MF;AEgNA;EACE,gBAAA;AF9MF;AEiNA;EACE,gBAAA;AF/MF;AEkNA;EACE,gBAAA;AFhNF;AEmNA;EACE,gBAAA;AFjNF;AEoNA;EACE,gBAAA;AFlNF;AEqNA;EACE,gBAAA;AFnNF;AEsNA;EACE,gBAAA;AFpNF;AEuNA;EACE,gBAAA;AFrNF;AEwNA;EACE,gBAAA;AFtNF;AEyNA;EACE,gBAAA;AFvNF;AE0NA;EACE,gBAAA;AFxNF;AE2NA;EACE,gBAAA;AFzNF;AE4NA;EACE,gBAAA;AF1NF;AE6NA;EACE,gBAAA;AF3NF;AE8NA;EACE,gBAAA;AF5NF;AE+NA;EACE,gBAAA;AF7NF;AEgOA;EACE,gBAAA;AF9NF;AEiOA;EACE,gBAAA;AF/NF;AEkOA;EACE,gBAAA;AFhOF;AEmOA;EACE,gBAAA;AFjOF;AEoOA;EACE,gBAAA;AFlOF;AEqOA;EACE,gBAAA;AFnOF;AEsOA;EACE,gBAAA;AFpOF;AEuOA;EACE,gBAAA;AFrOF;AEwOA;EACE,gBAAA;AFtOF;AEyOA;EACE,gBAAA;AFvOF;AE0OA;EACE,gBAAA;AFxOF;AE2OA;EACE,gBAAA;AFzOF;AE4OA;EACE,gBAAA;AF1OF;AE6OA;EACE,gBAAA;AF3OF;AE8OA;EACE,gBAAA;AF5OF;AE+OA;EACE,gBAAA;AF7OF;AEgPA;EACE,gBAAA;AF9OF;AEiPA;EACE,gBAAA;AF/OF;AEkPA;EACE,gBAAA;AFhPF;AEmPA;EACE,gBAAA;AFjPF;AEoPA;EACE,gBAAA;AFlPF;AEqPA;EACE,gBAAA;AFnPF;AEsPA;EACE,gBAAA;AFpPF;AEuPA;EACE,gBAAA;AFrPF;AEwPA;EACE,gBAAA;AFtPF;AEyPA;EACE,gBAAA;AFvPF;AE0PA;EACE,gBAAA;AFxPF;AE2PA;EACE,gBAAA;AFzPF;AE4PA;EACE,gBAAA;AF1PF;AE6PA;EACE,gBAAA;AF3PF;AE8PA;EACE,gBAAA;AF5PF;AE+PA;EACE,gBAAA;AF7PF;AEgQA;EACE,gBAAA;AF9PF;AEiQA;EACE,gBAAA;AF/PF;AEkQA;EACE,gBAAA;AFhQF;AEmQA;EACE,gBAAA;AFjQF;AEoQA;EACE,gBAAA;AFlQF;AEqQA;EACE,gBAAA;AFnQF;AEsQA;EACE,gBAAA;AFpQF;AEuQA;EACE,gBAAA;AFrQF;AEwQA;EACE,gBAAA;AFtQF;AEyQA;EACE,gBAAA;AFvQF;AE0QA;EACE,gBAAA;AFxQF;AE2QA;EACE,gBAAA;AFzQF;AE4QA;EACE,gBAAA;AF1QF;AE6QA;EACE,gBAAA;AF3QF;AE8QA;EACE,gBAAA;AF5QF;AE+QA;EACE,gBAAA;AF7QF;AEgRA;EACE,gBAAA;AF9QF;AEiRA;EACE,gBAAA;AF/QF;AEkRA;EACE,gBAAA;AFhRF;AEmRA;EACE,gBAAA;AFjRF;AEoRA;EACE,gBAAA;AFlRF;AEqRA;EACE,gBAAA;AFnRF;AEsRA;EACE,gBAAA;AFpRF;AEuRA;EACE,gBAAA;AFrRF;AEwRA;EACE,gBAAA;AFtRF;AEyRA;EACE,gBAAA;AFvRF;AE0RA;EACE,gBAAA;AFxRF;AE2RA;EACE,gBAAA;AFzRF;AE4RA;EACE,gBAAA;AF1RF;AE6RA;EACE,gBAAA;AF3RF;AE8RA;EACE,gBAAA;AF5RF;AE+RA;EACE,gBAAA;AF7RF;AEgSA;EACE,gBAAA;AF9RF;AEiSA;EACE,gBAAA;AF/RF;AEkSA;EACE,gBAAA;AFhSF;AEmSA;EACE,gBAAA;AFjSF;AEoSA;EACE,gBAAA;AFlSF;AEqSA;EACE,gBAAA;AFnSF;AEsSA;EACE,gBAAA;AFpSF;AEuSA;EACE,gBAAA;AFrSF;AEwSA;EACE,gBAAA;AFtSF;AEySA;EACE,gBAAA;AFvSF;AE0SA;EACE,gBAAA;AFxSF;AE2SA;EACE,gBAAA;AFzSF;AE4SA;EACE,gBAAA;AF1SF;AE6SA;EACE,gBAAA;AF3SF;AE8SA;EACE,gBAAA;AF5SF;AE+SA;EACE,gBAAA;AF7SF;AEgTA;EACE,gBAAA;AF9SF;AEiTA;EACE,gBAAA;AF/SF;AEkTA;EACE,gBAAA;AFhTF;AEmTA;EACE,gBAAA;AFjTF;AEoTA;EACE,gBAAA;AFlTF;AEqTA;EACE,gBAAA;AFnTF;AEsTA;EACE,gBAAA;AFpTF;AEuTA;EACE,gBAAA;AFrTF;AEwTA;EACE,gBAAA;AFtTF;AEyTA;EACE,gBAAA;AFvTF;AE0TA;EACE,gBAAA;AFxTF;AE2TA;EACE,gBAAA;AFzTF;AE4TA;EACE,gBAAA;AF1TF;AE6TA;EACE,gBAAA;AF3TF;AE8TA;EACE,gBAAA;AF5TF;AE+TA;EACE,gBAAA;AF7TF;AEgUA;EACE,gBAAA;AF9TF;AEiUA;EACE,gBAAA;AF/TF;AEkUA;EACE,gBAAA;AFhUF;AEmUA;EACE,gBAAA;AFjUF;AEoUA;EACE,gBAAA;AFlUF;AEqUA;EACE,gBAAA;AFnUF;AEsUA;EACE,gBAAA;AFpUF;AEuUA;EACE,gBAAA;AFrUF;AEwUA;EACE,gBAAA;AFtUF;AEyUA;EACE,gBAAA;AFvUF;AE0UA;EACE,gBAAA;AFxUF;AE2UA;EACE,gBAAA;AFzUF;AE4UA;EACE,gBAAA;AF1UF;AE6UA;EACE,gBAAA;AF3UF;AE8UA;EACE,gBAAA;AF5UF;AE+UA;EACE,gBAAA;AF7UF;AEgVA;EACE,gBAAA;AF9UF;AEiVA;EACE,gBAAA;AF/UF;AEkVA;EACE,gBAAA;AFhVF;AEmVA;EACE,gBAAA;AFjVF;AEoVA;EACE,gBAAA;AFlVF;AEqVA;EACE,gBAAA;AFnVF;AEsVA;EACE,gBAAA;AFpVF;AEuVA;EACE,gBAAA;AFrVF;AEwVA;EACE,gBAAA;AFtVF;AEyVA;EACE,gBAAA;AFvVF;AE0VA;EACE,gBAAA;AFxVF;AE2VA;EACE,gBAAA;AFzVF;AE4VA;EACE,gBAAA;AF1VF;AE6VA;EACE,gBAAA;AF3VF;AE8VA;EACE,gBAAA;AF5VF;AE+VA;EACE,gBAAA;AF7VF;AEgWA;EACE,gBAAA;AF9VF;AEiWA;EACE,gBAAA;AF/VF;AEkWA;EACE,gBAAA;AFhWF;AEmWA;EACE,gBAAA;AFjWF;AEoWA;EACE,gBAAA;AFlWF;AEqWA;EACE,gBAAA;AFnWF;AEsWA;EACE,gBAAA;AFpWF;AEuWA;EACE,gBAAA;AFrWF;AEwWA;EACE,gBAAA;AFtWF;AEyWA;EACE,gBAAA;AFvWF;AE0WA;EACE,gBAAA;AFxWF;AE2WA;EACE,gBAAA;AFzWF;AE4WA;EACE,gBAAA;AF1WF;AE6WA;EACE,gBAAA;AF3WF;AE8WA;EACE,gBAAA;AF5WF;AE+WA;EACE,gBAAA;AF7WF;AEgXA;EACE,gBAAA;AF9WF;AEiXA;EACE,gBAAA;AF/WF;AEkXA;EACE,gBAAA;AFhXF;AEmXA;EACE,gBAAA;AFjXF;AEoXA;EACE,gBAAA;AFlXF;AEqXA;EACE,gBAAA;AFnXF;AEsXA;EACE,gBAAA;AFpXF;AEuXA;EACE,gBAAA;AFrXF;AEwXA;EACE,gBAAA;AFtXF;AEyXA;EACE,gBAAA;AFvXF;AE0XA;EACE,gBAAA;AFxXF;AE2XA;EACE,gBAAA;AFzXF;AE4XA;EACE,gBAAA;AF1XF;AE6XA;EACE,gBAAA;AF3XF;AACA;;kCAEkC;AGtxBlC;EACE,sBAAA;EACA,6DAAA;EACA,mBAAA;EACA,kBAAA;AHwxBF;AIjyBA;EACI,8CAAA;EACA,0BAAA;EACA,wBAAA;EAEA,2BAAA;EAEA,gCAAA;EACA,gDAAA;EACA,2CAAA;EAEA,6BAAA;EACA,6BAAA;EAEA,kDAAA;EACA,oDAAA;EAEA,kCAAA;AJ8xBJ;AI/yBA;EAsBQ,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AJ4xBR;AI9zBA;EAsCQ,uBAAA;AJ2xBR;AIj0BA;EA0CQ,0CAAA;AJ0xBR;AIp0BA;EA8CQ,2BAAA;EACA,6BAAA;AJyxBR;AAl0BA;;;EAGI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,oBAAA;EACA,gBAAA;EACA,oCAAA;AAo0BJ;AAj0BA;EACI,kBAAA;EACA,gBAAA;AAm0BJ;AA/zBA;EACI,eAAA;AAi0BJ;AA5zBA;EACI,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,2BAAA;EACA,mBAAA;AA8zBJ;AAzzBI;;EAEI,cAAA;AA2zBR;AAxzBI;;EAEI,cAAA;AA0zBR;AAtzBA;EACI,eAAA;EACA,YAAA;AAwzBJ","sourcesContent":["@import './open-sans.less';\n@import '@cw/icons/src/_cw-material-icon-woff2.less';\n@import 'material-icons/iconfont/filled.css';\n@import 'bootstrap/dist/css/bootstrap.min.css';\n@import './global-vars.less';\n\nhtml,\nbody,\n#root {\n    position: relative;\n    margin: 0;\n    padding: 0;\n    min-block-size: 100%;\n    block-size: 100%;\n    font-family: 'Open Sans', sans-serif;\n}\n\n.RootShell {\n    position: relative;\n    block-size: 100%;\n}\n\n\nbutton {\n    cursor: pointer;\n}\n\n\n// Override bootstrap\nbutton.btn[type=\"button\"] {\n    display: inline-flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    align-content: center;\n    justify-content: flex-start;\n    align-items: center;\n}\n\na:not(.btn, .dropdown-item) {\n\n    &:visited,\n    &:active {\n        color: @col_trimble_blue_light;\n    }\n\n    &:hover,\n    &:focus-visible {\n        color: @col_trimble_blue;\n    }\n}\n\n.cw-icon {\n    font-size: 18px;\n    padding: 3px;\n}","/* open-sans-cyrillic-ext-400-normal*/\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-display: swap;\n  font-weight: 400;\n  src: url('./files/open-sans-cyrillic-ext-400-normal.woff2') format('woff2'), url('./files/open-sans-all-400-normal.woff') format('woff');\n  unicode-range: U+0460-052F,U+1C80-1C88,U+20B4,U+2DE0-2DFF,U+A640-A69F,U+FE2E-FE2F;\n}\n/* open-sans-cyrillic-400-normal*/\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-display: swap;\n  font-weight: 400;\n  src: url('./files/open-sans-cyrillic-400-normal.woff2') format('woff2'), url('./files/open-sans-all-400-normal.woff') format('woff');\n  unicode-range: U+0301,U+0400-045F,U+0490-0491,U+04B0-04B1,U+2116;\n}\n/* open-sans-greek-ext-400-normal*/\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-display: swap;\n  font-weight: 400;\n  src: url('./files/open-sans-greek-ext-400-normal.woff2') format('woff2'), url('./files/open-sans-all-400-normal.woff') format('woff');\n  unicode-range: U+1F00-1FFF;\n}\n/* open-sans-greek-400-normal*/\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-display: swap;\n  font-weight: 400;\n  src: url('./files/open-sans-greek-400-normal.woff2') format('woff2'), url('./files/open-sans-all-400-normal.woff') format('woff');\n  unicode-range: U+0370-03FF;\n}\n/* open-sans-hebrew-400-normal*/\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-display: swap;\n  font-weight: 400;\n  src: url('./files/open-sans-hebrew-400-normal.woff2') format('woff2'), url('./files/open-sans-all-400-normal.woff') format('woff');\n  unicode-range: U+0590-05FF,U+200C-2010,U+20AA,U+25CC,U+FB1D-FB4F;\n}\n/* open-sans-vietnamese-400-normal*/\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-display: swap;\n  font-weight: 400;\n  src: url('./files/open-sans-vietnamese-400-normal.woff2') format('woff2'), url('./files/open-sans-all-400-normal.woff') format('woff');\n  unicode-range: U+0102-0103,U+0110-0111,U+0128-0129,U+0168-0169,U+01A0-01A1,U+01AF-01B0,U+1EA0-1EF9,U+20AB;\n}\n/* open-sans-latin-ext-400-normal*/\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-display: swap;\n  font-weight: 400;\n  src: url('./files/open-sans-latin-ext-400-normal.woff2') format('woff2'), url('./files/open-sans-all-400-normal.woff') format('woff');\n  unicode-range: U+0100-024F,U+0259,U+1E00-1EFF,U+2020,U+20A0-20AB,U+20AD-20CF,U+2113,U+2C60-2C7F,U+A720-A7FF;\n}\n/* open-sans-latin-400-normal*/\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-display: swap;\n  font-weight: 400;\n  src: url('./files/open-sans-latin-400-normal.woff2') format('woff2'), url('./files/open-sans-all-400-normal.woff') format('woff');\n  unicode-range: U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD;\n}\n","/*--------------------------------\n\ncw-icon icon font\nGenerated using nucleoapp.com\n\n-------------------------------- */\n\n@cw-icon-font-path: \"../fonts\";\n\n@font-face {\n  font-family: 'cw-icon';\n  src: url('@{cw-icon-font-path}/cw-icon.eot');\n  src: url('@{cw-icon-font-path}/cw-icon.eot') format('embedded-opentype'),\n       url('@{cw-icon-font-path}/cw-icon.woff2') format('woff2'),\n       url('@{cw-icon-font-path}/cw-icon.woff') format('woff'),\n       url('@{cw-icon-font-path}/cw-icon.ttf') format('truetype'),\n       url('@{cw-icon-font-path}/cw-icon.svg') format('svg');\n}\n\n/* base class */\n.cw-icon {\n  display: inline-block;\n  font: normal normal normal 1em/1 'cw-icon';\n  color: inherit;\n  flex-shrink: 0;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* size examples - relative units */\n.cw-icon-sm {\n\tfont-size: 0.8em;\n}\n\n.cw-icon-lg {\n  font-size: 1.2em;\n}\n\n/* size examples - absolute units */\n.cw-icon-16 {\n  font-size: 16px;\n}\n\n.cw-icon-32 {\n  font-size: 32px;\n}\n\n/* rotate the icon infinitely */\n.cw-icon-is-spinning {\n  animation: cw-icon-spin 1s infinite linear;\n}\n\n@keyframes cw-icon-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* transform */\n.cw-icon-rotate-90  {\n\ttransform: rotate(90deg);\n}\n\n.cw-icon-rotate-180 {\n\ttransform: rotate(180deg);\n}\n\n.cw-icon-rotate-270 {\n\ttransform: rotate(270deg);\n}\n\n.cw-icon-flip-y {\n\ttransform: scaleY(-1);\n}\n\n.cw-icon-flip-x {\n\ttransform: scaleX(-1);\n}\n\n/* icons */\n@cw-icon-map-pin: \"\\ea18\";\n@cw-icon-hierarchy: \"\\ea19\";\n@cw-icon-input-arrow-up: \"\\ea1a\";\n@cw-icon-import: \"\\ea1b\";\n@cw-icon-full-screen-exit: \"\\ea1c\";\n@cw-icon-drag: \"\\ea1d\";\n@cw-icon-cost-details: \"\\ea1e\";\n@cw-icon-undo: \"\\ea1f\";\n@cw-icon-redo: \"\\ea20\";\n@cw-icon-pin: \"\\ea21\";\n@cw-icon-map-stack: \"\\ea22\";\n@cw-icon-input-plus: \"\\ea23\";\n@cw-icon-input-minus: \"\\ea24\";\n@cw-icon-input-calendar: \"\\ea25\";\n@cw-icon-hide-map-pin: \"\\ea26\";\n@cw-icon-input-arrow-down: \"\\ea27\";\n@cw-icon-collapse-all: \"\\ea28\";\n@cw-icon-calendar: \"\\ea29\";\n@cw-icon-swap: \"\\ea2a\";\n@cw-icon-utility: \"\\ea2b\";\n@cw-icon-world: \"\\ea2c\";\n@cw-icon-work-order: \"\\ea2d\";\n@cw-icon-audit: \"\\ea2e\";\n@cw-icon-arrow-right: \"\\ea2f\";\n@cw-icon-web: \"\\ea30\";\n@cw-icon-water: \"\\ea31\";\n@cw-icon-waive: \"\\ea32\";\n@cw-icon-wait: \"\\ea33\";\n@cw-icon-info: \"\\ea34\";\n@cw-icon-user: \"\\ea35\";\n@cw-icon-user-female: \"\\ea36\";\n@cw-icon-unflag: \"\\ea37\";\n@cw-icon-unfavorite: \"\\ea38\";\n@cw-icon-tv: \"\\ea39\";\n@cw-icon-transportation: \"\\ea3a\";\n@cw-icon-transfer: \"\\ea3b\";\n@cw-icon-traffic-light: \"\\ea3c\";\n@cw-icon-timer: \"\\ea3d\";\n@cw-icon-time: \"\\ea3e\";\n@cw-icon-task: \"\\ea3f\";\n@cw-icon-tag: \"\\ea40\";\n@cw-icon-table: \"\\ea41\";\n@cw-icon-supplier: \"\\ea42\";\n@cw-icon-strategy: \"\\ea43\";\n@cw-icon-storeroom: \"\\ea44\";\n@cw-icon-split-screen: \"\\ea45\";\n@cw-icon-sort-descending: \"\\ea46\";\n@cw-icon-sort-ascending: \"\\ea47\";\n@cw-icon-show: \"\\ea48\";\n@cw-icon-shock: \"\\ea49\";\n@cw-icon-settings: \"\\ea4a\";\n@cw-icon-service-request: \"\\ea4b\";\n@cw-icon-send: \"\\ea4c\";\n@cw-icon-secure: \"\\ea4d\";\n@cw-icon-search: \"\\ea4e\";\n@cw-icon-scan: \"\\ea4f\";\n@cw-icon-save: \"\\ea50\";\n@cw-icon-rows: \"\\ea51\";\n@cw-icon-roadwork: \"\\ea52\";\n@cw-icon-reset: \"\\ea53\";\n@cw-icon-requisition: \"\\ea54\";\n@cw-icon-recent: \"\\ea55\";\n@cw-icon-receive: \"\\ea56\";\n@cw-icon-project: \"\\ea57\";\n@cw-icon-power: \"\\ea58\";\n@cw-icon-pll: \"\\ea59\";\n@cw-icon-pinpoint: \"\\ea5a\";\n@cw-icon-phone: \"\\ea5b\";\n@cw-icon-percent: \"\\ea5c\";\n@cw-icon-payment: \"\\ea5d\";\n@cw-icon-park: \"\\ea5e\";\n@cw-icon-pan: \"\\ea5f\";\n@cw-icon-open: \"\\ea60\";\n@cw-icon-notification: \"\\ea61\";\n@cw-icon-next: \"\\ea62\";\n@cw-icon-navigate: \"\\ea63\";\n@cw-icon-mobile: \"\\ea64\";\n@cw-icon-minimize: \"\\ea65\";\n@cw-icon-microphone: \"\\ea66\";\n@cw-icon-menu: \"\\ea67\";\n@cw-icon-material: \"\\ea68\";\n@cw-icon-map: \"\\ea69\";\n@cw-icon-maintenance: \"\\ea6a\";\n@cw-icon-mail: \"\\ea6b\";\n@cw-icon-mail-open: \"\\ea6c\";\n@cw-icon-love: \"\\ea6d\";\n@cw-icon-logout: \"\\ea6e\";\n@cw-icon-lock: \"\\ea6f\";\n@cw-icon-link: \"\\ea70\";\n@cw-icon-like: \"\\ea71\";\n@cw-icon-layers: \"\\ea72\";\n@cw-icon-issue: \"\\ea73\";\n@cw-icon-invert: \"\\ea74\";\n@cw-icon-inspection: \"\\ea75\";\n@cw-icon-apps: \"\\ea76\";\n@cw-icon-image: \"\\ea77\";\n@cw-icon-idea: \"\\ea78\";\n@cw-icon-hydrant: \"\\ea79\";\n@cw-icon-html: \"\\ea7a\";\n@cw-icon-home: \"\\ea7b\";\n@cw-icon-hide: \"\\ea7c\";\n@cw-icon-hide-map: \"\\ea7d\";\n@cw-icon-help: \"\\ea7e\";\n@cw-icon-group: \"\\ea7f\";\n@cw-icon-funnel: \"\\ea80\";\n@cw-icon-full-screen: \"\\ea81\";\n@cw-icon-cctv: \"\\ea82\";\n@cw-icon-configure: \"\\ea83\";\n@cw-icon-flag: \"\\ea84\";\n@cw-icon-budget: \"\\ea85\";\n@cw-icon-filter: \"\\ea86\";\n@cw-icon-file-video: \"\\ea87\";\n@cw-icon-file-txt: \"\\ea88\";\n@cw-icon-file-pdf: \"\\ea89\";\n@cw-icon-file-doc: \"\\ea8a\";\n@cw-icon-file-csv: \"\\ea8b\";\n@cw-icon-file-blank: \"\\ea8c\";\n@cw-icon-fee: \"\\ea8d\";\n@cw-icon-favorite: \"\\ea8e\";\n@cw-icon-export: \"\\ea8f\";\n@cw-icon-expand-up: \"\\ea90\";\n@cw-icon-expand-right: \"\\ea91\";\n@cw-icon-expand-panel: \"\\ea92\";\n@cw-icon-expand-left: \"\\ea93\";\n@cw-icon-expand-down: \"\\ea94\";\n@cw-icon-expand-all: \"\\ea95\";\n@cw-icon-estimate: \"\\ea96\";\n@cw-icon-erase: \"\\ea97\";\n@cw-icon-ellipsis-vertical: \"\\ea98\";\n@cw-icon-ellipsis-horizontal: \"\\ea99\";\n@cw-icon-edit: \"\\ea9a\";\n@cw-icon-edit-circle: \"\\ea9b\";\n@cw-icon-duration: \"\\ea9c\";\n@cw-icon-drop: \"\\ea9d\";\n@cw-icon-drag-up: \"\\ea9e\";\n@cw-icon-drag-right: \"\\ea9f\";\n@cw-icon-drag-left: \"\\eaa0\";\n@cw-icon-drag-down: \"\\eaa1\";\n@cw-icon-delete: \"\\eaa2\";\n@cw-icon-dashboard: \"\\eaa3\";\n@cw-icon-customize: \"\\eaa4\";\n@cw-icon-counter: \"\\eaa5\";\n@cw-icon-construction: \"\\eaa6\";\n@cw-icon-chart-line: \"\\eaa7\";\n@cw-icon-complete: \"\\eaa8\";\n@cw-icon-compass: \"\\eaa9\";\n@cw-icon-comment: \"\\eaaa\";\n@cw-icon-columns: \"\\eaab\";\n@cw-icon-collapse: \"\\eaac\";\n@cw-icon-cloud: \"\\eaad\";\n@cw-icon-close: \"\\eaae\";\n@cw-icon-close-circle: \"\\eaaf\";\n@cw-icon-clone: \"\\eab0\";\n@cw-icon-clone-circle: \"\\eab1\";\n@cw-icon-check-circle: \"\\eab2\";\n@cw-icon-chart-spline: \"\\eab3\";\n@cw-icon-chart-pie: \"\\eab4\";\n@cw-icon-add: \"\\eab5\";\n@cw-icon-chart-curve: \"\\eab6\";\n@cw-icon-chart-column: \"\\eab7\";\n@cw-icon-chart-bar: \"\\eab8\";\n@cw-icon-center-on-map: \"\\eab9\";\n@cw-icon-bug: \"\\eaba\";\n@cw-icon-caution: \"\\eabb\";\n@cw-icon-case: \"\\eabc\";\n@cw-icon-cancel: \"\\eabd\";\n@cw-icon-calculator: \"\\eabe\";\n@cw-icon-arrow-left: \"\\eabf\";\n@cw-icon-add-circle: \"\\eac0\";\n@cw-icon-bookmark: \"\\eac1\";\n@cw-icon-barcode: \"\\eac2\";\n@cw-icon-auto: \"\\eac3\";\n@cw-icon-arrow-up: \"\\eac4\";\n@cw-icon-audio: \"\\eac5\";\n@cw-icon-attach: \"\\eac6\";\n@cw-icon-asset: \"\\eac7\";\n@cw-icon-assembly: \"\\eac8\";\n@cw-icon-ask: \"\\eac9\";\n@cw-icon-arrow-down: \"\\eaca\";\n@cw-icon-abc: \"\\eacb\";\n@cw-icon-search-circle: \"\\ead0\";\n@cw-icon-preview: \"\\ead1\";\n@cw-icon-collapse-panel: \"\\ead9\";\n@cw-icon-text-underline: \"\\eada\";\n@cw-icon-text-strikethrough: \"\\eadd\";\n@cw-icon-text-italic: \"\\eade\";\n@cw-icon-text-bold: \"\\eadf\";\n@cw-icon-list-number: \"\\eae0\";\n@cw-icon-list-bullet: \"\\eae1\";\n@cw-icon-at: \"\\eae2\";\n@cw-icon-text-superscript: \"\\eae3\";\n@cw-icon-text-subscript: \"\\eae4\";\n@cw-icon-file-shp: \"\\eae6\";\n@cw-icon-expand-all-panels: \"\\eae8\";\n@cw-icon-collapse-all-panels: \"\\eaea\";\n@cw-icon-uncheck-all: \"\\eaeb\";\n@cw-icon-check-all: \"\\eaec\";\n@cw-icon-portal: \"\\eaed\";\n@cw-icon-menu-page: \"\\eaee\";\n@cw-icon-split-screen-collapse: \"\\eaef\";\n@cw-icon-cityworks-logo: \"\\eaf0\";\n@cw-icon-download: \"\\eaf1\";\n@cw-icon-watch: \"\\eaf2\";\n@cw-icon-not-watching: \"\\eaf3\";\n@cw-icon-review: \"\\eaf4\";\n@cw-icon-hearing: \"\\eaf5\";\n@cw-icon-last: \"\\eaf6\";\n@cw-icon-first: \"\\eaf7\";\n@cw-icon-host: \"\\eaf8\";\n@cw-icon-upload: \"\\eaf9\";\n@cw-icon-task-group: \"\\eafa\";\n@cw-icon-split-screen-swap-sides: \"\\eafb\";\n@cw-icon-split-screen-expand-right: \"\\eafc\";\n@cw-icon-split-screen-expand-left: \"\\eafd\";\n@cw-icon-notification-add: \"\\eafe\";\n@cw-icon-previous: \"\\eaff\";\n@cw-icon-filter-table: \"\\eb00\";\n@cw-icon-agol: \"\\eb01\";\n\n.cw-icon-map-pin::before {\n  content: @cw-icon-map-pin;\n}\n\n.cw-icon-hierarchy::before {\n  content: @cw-icon-hierarchy;\n}\n\n.cw-icon-input-arrow-up::before {\n  content: @cw-icon-input-arrow-up;\n}\n\n.cw-icon-import::before {\n  content: @cw-icon-import;\n}\n\n.cw-icon-full-screen-exit::before {\n  content: @cw-icon-full-screen-exit;\n}\n\n.cw-icon-drag::before {\n  content: @cw-icon-drag;\n}\n\n.cw-icon-cost-details::before {\n  content: @cw-icon-cost-details;\n}\n\n.cw-icon-undo::before {\n  content: @cw-icon-undo;\n}\n\n.cw-icon-redo::before {\n  content: @cw-icon-redo;\n}\n\n.cw-icon-pin::before {\n  content: @cw-icon-pin;\n}\n\n.cw-icon-map-stack::before {\n  content: @cw-icon-map-stack;\n}\n\n.cw-icon-input-plus::before {\n  content: @cw-icon-input-plus;\n}\n\n.cw-icon-input-minus::before {\n  content: @cw-icon-input-minus;\n}\n\n.cw-icon-input-calendar::before {\n  content: @cw-icon-input-calendar;\n}\n\n.cw-icon-hide-map-pin::before {\n  content: @cw-icon-hide-map-pin;\n}\n\n.cw-icon-input-arrow-down::before {\n  content: @cw-icon-input-arrow-down;\n}\n\n.cw-icon-collapse-all::before {\n  content: @cw-icon-collapse-all;\n}\n\n.cw-icon-calendar::before {\n  content: @cw-icon-calendar;\n}\n\n.cw-icon-swap::before {\n  content: @cw-icon-swap;\n}\n\n.cw-icon-utility::before {\n  content: @cw-icon-utility;\n}\n\n.cw-icon-world::before {\n  content: @cw-icon-world;\n}\n\n.cw-icon-work-order::before {\n  content: @cw-icon-work-order;\n}\n\n.cw-icon-audit::before {\n  content: @cw-icon-audit;\n}\n\n.cw-icon-arrow-right::before {\n  content: @cw-icon-arrow-right;\n}\n\n.cw-icon-web::before {\n  content: @cw-icon-web;\n}\n\n.cw-icon-water::before {\n  content: @cw-icon-water;\n}\n\n.cw-icon-waive::before {\n  content: @cw-icon-waive;\n}\n\n.cw-icon-wait::before {\n  content: @cw-icon-wait;\n}\n\n.cw-icon-info::before {\n  content: @cw-icon-info;\n}\n\n.cw-icon-user::before {\n  content: @cw-icon-user;\n}\n\n.cw-icon-user-female::before {\n  content: @cw-icon-user-female;\n}\n\n.cw-icon-unflag::before {\n  content: @cw-icon-unflag;\n}\n\n.cw-icon-unfavorite::before {\n  content: @cw-icon-unfavorite;\n}\n\n.cw-icon-tv::before {\n  content: @cw-icon-tv;\n}\n\n.cw-icon-transportation::before {\n  content: @cw-icon-transportation;\n}\n\n.cw-icon-transfer::before {\n  content: @cw-icon-transfer;\n}\n\n.cw-icon-traffic-light::before {\n  content: @cw-icon-traffic-light;\n}\n\n.cw-icon-timer::before {\n  content: @cw-icon-timer;\n}\n\n.cw-icon-time::before {\n  content: @cw-icon-time;\n}\n\n.cw-icon-task::before {\n  content: @cw-icon-task;\n}\n\n.cw-icon-tag::before {\n  content: @cw-icon-tag;\n}\n\n.cw-icon-table::before {\n  content: @cw-icon-table;\n}\n\n.cw-icon-supplier::before {\n  content: @cw-icon-supplier;\n}\n\n.cw-icon-strategy::before {\n  content: @cw-icon-strategy;\n}\n\n.cw-icon-storeroom::before {\n  content: @cw-icon-storeroom;\n}\n\n.cw-icon-split-screen::before {\n  content: @cw-icon-split-screen;\n}\n\n.cw-icon-sort-descending::before {\n  content: @cw-icon-sort-descending;\n}\n\n.cw-icon-sort-ascending::before {\n  content: @cw-icon-sort-ascending;\n}\n\n.cw-icon-show::before {\n  content: @cw-icon-show;\n}\n\n.cw-icon-shock::before {\n  content: @cw-icon-shock;\n}\n\n.cw-icon-settings::before {\n  content: @cw-icon-settings;\n}\n\n.cw-icon-service-request::before {\n  content: @cw-icon-service-request;\n}\n\n.cw-icon-send::before {\n  content: @cw-icon-send;\n}\n\n.cw-icon-secure::before {\n  content: @cw-icon-secure;\n}\n\n.cw-icon-search::before {\n  content: @cw-icon-search;\n}\n\n.cw-icon-scan::before {\n  content: @cw-icon-scan;\n}\n\n.cw-icon-save::before {\n  content: @cw-icon-save;\n}\n\n.cw-icon-rows::before {\n  content: @cw-icon-rows;\n}\n\n.cw-icon-roadwork::before {\n  content: @cw-icon-roadwork;\n}\n\n.cw-icon-reset::before {\n  content: @cw-icon-reset;\n}\n\n.cw-icon-requisition::before {\n  content: @cw-icon-requisition;\n}\n\n.cw-icon-recent::before {\n  content: @cw-icon-recent;\n}\n\n.cw-icon-receive::before {\n  content: @cw-icon-receive;\n}\n\n.cw-icon-project::before {\n  content: @cw-icon-project;\n}\n\n.cw-icon-power::before {\n  content: @cw-icon-power;\n}\n\n.cw-icon-pll::before {\n  content: @cw-icon-pll;\n}\n\n.cw-icon-pinpoint::before {\n  content: @cw-icon-pinpoint;\n}\n\n.cw-icon-phone::before {\n  content: @cw-icon-phone;\n}\n\n.cw-icon-percent::before {\n  content: @cw-icon-percent;\n}\n\n.cw-icon-payment::before {\n  content: @cw-icon-payment;\n}\n\n.cw-icon-park::before {\n  content: @cw-icon-park;\n}\n\n.cw-icon-pan::before {\n  content: @cw-icon-pan;\n}\n\n.cw-icon-open::before {\n  content: @cw-icon-open;\n}\n\n.cw-icon-notification::before {\n  content: @cw-icon-notification;\n}\n\n.cw-icon-next::before {\n  content: @cw-icon-next;\n}\n\n.cw-icon-navigate::before {\n  content: @cw-icon-navigate;\n}\n\n.cw-icon-mobile::before {\n  content: @cw-icon-mobile;\n}\n\n.cw-icon-minimize::before {\n  content: @cw-icon-minimize;\n}\n\n.cw-icon-microphone::before {\n  content: @cw-icon-microphone;\n}\n\n.cw-icon-menu::before {\n  content: @cw-icon-menu;\n}\n\n.cw-icon-material::before {\n  content: @cw-icon-material;\n}\n\n.cw-icon-map::before {\n  content: @cw-icon-map;\n}\n\n.cw-icon-maintenance::before {\n  content: @cw-icon-maintenance;\n}\n\n.cw-icon-mail::before {\n  content: @cw-icon-mail;\n}\n\n.cw-icon-mail-open::before {\n  content: @cw-icon-mail-open;\n}\n\n.cw-icon-love::before {\n  content: @cw-icon-love;\n}\n\n.cw-icon-logout::before {\n  content: @cw-icon-logout;\n}\n\n.cw-icon-lock::before {\n  content: @cw-icon-lock;\n}\n\n.cw-icon-link::before {\n  content: @cw-icon-link;\n}\n\n.cw-icon-like::before {\n  content: @cw-icon-like;\n}\n\n.cw-icon-layers::before {\n  content: @cw-icon-layers;\n}\n\n.cw-icon-issue::before {\n  content: @cw-icon-issue;\n}\n\n.cw-icon-invert::before {\n  content: @cw-icon-invert;\n}\n\n.cw-icon-inspection::before {\n  content: @cw-icon-inspection;\n}\n\n.cw-icon-apps::before {\n  content: @cw-icon-apps;\n}\n\n.cw-icon-image::before {\n  content: @cw-icon-image;\n}\n\n.cw-icon-idea::before {\n  content: @cw-icon-idea;\n}\n\n.cw-icon-hydrant::before {\n  content: @cw-icon-hydrant;\n}\n\n.cw-icon-html::before {\n  content: @cw-icon-html;\n}\n\n.cw-icon-home::before {\n  content: @cw-icon-home;\n}\n\n.cw-icon-hide::before {\n  content: @cw-icon-hide;\n}\n\n.cw-icon-hide-map::before {\n  content: @cw-icon-hide-map;\n}\n\n.cw-icon-help::before {\n  content: @cw-icon-help;\n}\n\n.cw-icon-group::before {\n  content: @cw-icon-group;\n}\n\n.cw-icon-funnel::before {\n  content: @cw-icon-funnel;\n}\n\n.cw-icon-full-screen::before {\n  content: @cw-icon-full-screen;\n}\n\n.cw-icon-cctv::before {\n  content: @cw-icon-cctv;\n}\n\n.cw-icon-configure::before {\n  content: @cw-icon-configure;\n}\n\n.cw-icon-flag::before {\n  content: @cw-icon-flag;\n}\n\n.cw-icon-budget::before {\n  content: @cw-icon-budget;\n}\n\n.cw-icon-filter::before {\n  content: @cw-icon-filter;\n}\n\n.cw-icon-file-video::before {\n  content: @cw-icon-file-video;\n}\n\n.cw-icon-file-txt::before {\n  content: @cw-icon-file-txt;\n}\n\n.cw-icon-file-pdf::before {\n  content: @cw-icon-file-pdf;\n}\n\n.cw-icon-file-doc::before {\n  content: @cw-icon-file-doc;\n}\n\n.cw-icon-file-csv::before {\n  content: @cw-icon-file-csv;\n}\n\n.cw-icon-file-blank::before {\n  content: @cw-icon-file-blank;\n}\n\n.cw-icon-fee::before {\n  content: @cw-icon-fee;\n}\n\n.cw-icon-favorite::before {\n  content: @cw-icon-favorite;\n}\n\n.cw-icon-export::before {\n  content: @cw-icon-export;\n}\n\n.cw-icon-expand-up::before {\n  content: @cw-icon-expand-up;\n}\n\n.cw-icon-expand-right::before {\n  content: @cw-icon-expand-right;\n}\n\n.cw-icon-expand-panel::before {\n  content: @cw-icon-expand-panel;\n}\n\n.cw-icon-expand-left::before {\n  content: @cw-icon-expand-left;\n}\n\n.cw-icon-expand-down::before {\n  content: @cw-icon-expand-down;\n}\n\n.cw-icon-expand-all::before {\n  content: @cw-icon-expand-all;\n}\n\n.cw-icon-estimate::before {\n  content: @cw-icon-estimate;\n}\n\n.cw-icon-erase::before {\n  content: @cw-icon-erase;\n}\n\n.cw-icon-ellipsis-vertical::before {\n  content: @cw-icon-ellipsis-vertical;\n}\n\n.cw-icon-ellipsis-horizontal::before {\n  content: @cw-icon-ellipsis-horizontal;\n}\n\n.cw-icon-edit::before {\n  content: @cw-icon-edit;\n}\n\n.cw-icon-edit-circle::before {\n  content: @cw-icon-edit-circle;\n}\n\n.cw-icon-duration::before {\n  content: @cw-icon-duration;\n}\n\n.cw-icon-drop::before {\n  content: @cw-icon-drop;\n}\n\n.cw-icon-drag-up::before {\n  content: @cw-icon-drag-up;\n}\n\n.cw-icon-drag-right::before {\n  content: @cw-icon-drag-right;\n}\n\n.cw-icon-drag-left::before {\n  content: @cw-icon-drag-left;\n}\n\n.cw-icon-drag-down::before {\n  content: @cw-icon-drag-down;\n}\n\n.cw-icon-delete::before {\n  content: @cw-icon-delete;\n}\n\n.cw-icon-dashboard::before {\n  content: @cw-icon-dashboard;\n}\n\n.cw-icon-customize::before {\n  content: @cw-icon-customize;\n}\n\n.cw-icon-counter::before {\n  content: @cw-icon-counter;\n}\n\n.cw-icon-construction::before {\n  content: @cw-icon-construction;\n}\n\n.cw-icon-chart-line::before {\n  content: @cw-icon-chart-line;\n}\n\n.cw-icon-complete::before {\n  content: @cw-icon-complete;\n}\n\n.cw-icon-compass::before {\n  content: @cw-icon-compass;\n}\n\n.cw-icon-comment::before {\n  content: @cw-icon-comment;\n}\n\n.cw-icon-columns::before {\n  content: @cw-icon-columns;\n}\n\n.cw-icon-collapse::before {\n  content: @cw-icon-collapse;\n}\n\n.cw-icon-cloud::before {\n  content: @cw-icon-cloud;\n}\n\n.cw-icon-close::before {\n  content: @cw-icon-close;\n}\n\n.cw-icon-close-circle::before {\n  content: @cw-icon-close-circle;\n}\n\n.cw-icon-clone::before {\n  content: @cw-icon-clone;\n}\n\n.cw-icon-clone-circle::before {\n  content: @cw-icon-clone-circle;\n}\n\n.cw-icon-check-circle::before {\n  content: @cw-icon-check-circle;\n}\n\n.cw-icon-chart-spline::before {\n  content: @cw-icon-chart-spline;\n}\n\n.cw-icon-chart-pie::before {\n  content: @cw-icon-chart-pie;\n}\n\n.cw-icon-add::before {\n  content: @cw-icon-add;\n}\n\n.cw-icon-chart-curve::before {\n  content: @cw-icon-chart-curve;\n}\n\n.cw-icon-chart-column::before {\n  content: @cw-icon-chart-column;\n}\n\n.cw-icon-chart-bar::before {\n  content: @cw-icon-chart-bar;\n}\n\n.cw-icon-center-on-map::before {\n  content: @cw-icon-center-on-map;\n}\n\n.cw-icon-bug::before {\n  content: @cw-icon-bug;\n}\n\n.cw-icon-caution::before {\n  content: @cw-icon-caution;\n}\n\n.cw-icon-case::before {\n  content: @cw-icon-case;\n}\n\n.cw-icon-cancel::before {\n  content: @cw-icon-cancel;\n}\n\n.cw-icon-calculator::before {\n  content: @cw-icon-calculator;\n}\n\n.cw-icon-arrow-left::before {\n  content: @cw-icon-arrow-left;\n}\n\n.cw-icon-add-circle::before {\n  content: @cw-icon-add-circle;\n}\n\n.cw-icon-bookmark::before {\n  content: @cw-icon-bookmark;\n}\n\n.cw-icon-barcode::before {\n  content: @cw-icon-barcode;\n}\n\n.cw-icon-auto::before {\n  content: @cw-icon-auto;\n}\n\n.cw-icon-arrow-up::before {\n  content: @cw-icon-arrow-up;\n}\n\n.cw-icon-audio::before {\n  content: @cw-icon-audio;\n}\n\n.cw-icon-attach::before {\n  content: @cw-icon-attach;\n}\n\n.cw-icon-asset::before {\n  content: @cw-icon-asset;\n}\n\n.cw-icon-assembly::before {\n  content: @cw-icon-assembly;\n}\n\n.cw-icon-ask::before {\n  content: @cw-icon-ask;\n}\n\n.cw-icon-arrow-down::before {\n  content: @cw-icon-arrow-down;\n}\n\n.cw-icon-abc::before {\n  content: @cw-icon-abc;\n}\n\n.cw-icon-search-circle::before {\n  content: @cw-icon-search-circle;\n}\n\n.cw-icon-preview::before {\n  content: @cw-icon-preview;\n}\n\n.cw-icon-collapse-panel::before {\n  content: @cw-icon-collapse-panel;\n}\n\n.cw-icon-text-underline::before {\n  content: @cw-icon-text-underline;\n}\n\n.cw-icon-text-strikethrough::before {\n  content: @cw-icon-text-strikethrough;\n}\n\n.cw-icon-text-italic::before {\n  content: @cw-icon-text-italic;\n}\n\n.cw-icon-text-bold::before {\n  content: @cw-icon-text-bold;\n}\n\n.cw-icon-list-number::before {\n  content: @cw-icon-list-number;\n}\n\n.cw-icon-list-bullet::before {\n  content: @cw-icon-list-bullet;\n}\n\n.cw-icon-at::before {\n  content: @cw-icon-at;\n}\n\n.cw-icon-text-superscript::before {\n  content: @cw-icon-text-superscript;\n}\n\n.cw-icon-text-subscript::before {\n  content: @cw-icon-text-subscript;\n}\n\n.cw-icon-file-shp::before {\n  content: @cw-icon-file-shp;\n}\n\n.cw-icon-expand-all-panels::before {\n  content: @cw-icon-expand-all-panels;\n}\n\n.cw-icon-collapse-all-panels::before {\n  content: @cw-icon-collapse-all-panels;\n}\n\n.cw-icon-uncheck-all::before {\n  content: @cw-icon-uncheck-all;\n}\n\n.cw-icon-check-all::before {\n  content: @cw-icon-check-all;\n}\n\n.cw-icon-portal::before {\n  content: @cw-icon-portal;\n}\n\n.cw-icon-menu-page::before {\n  content: @cw-icon-menu-page;\n}\n\n.cw-icon-split-screen-collapse::before {\n  content: @cw-icon-split-screen-collapse;\n}\n\n.cw-icon-cityworks-logo::before {\n  content: @cw-icon-cityworks-logo;\n}\n\n.cw-icon-download::before {\n  content: @cw-icon-download;\n}\n\n.cw-icon-watch::before {\n  content: @cw-icon-watch;\n}\n\n.cw-icon-not-watching::before {\n  content: @cw-icon-not-watching;\n}\n\n.cw-icon-review::before {\n  content: @cw-icon-review;\n}\n\n.cw-icon-hearing::before {\n  content: @cw-icon-hearing;\n}\n\n.cw-icon-last::before {\n  content: @cw-icon-last;\n}\n\n.cw-icon-first::before {\n  content: @cw-icon-first;\n}\n\n.cw-icon-host::before {\n  content: @cw-icon-host;\n}\n\n.cw-icon-upload::before {\n  content: @cw-icon-upload;\n}\n\n.cw-icon-task-group::before {\n  content: @cw-icon-task-group;\n}\n\n.cw-icon-split-screen-swap-sides::before {\n  content: @cw-icon-split-screen-swap-sides;\n}\n\n.cw-icon-split-screen-expand-right::before {\n  content: @cw-icon-split-screen-expand-right;\n}\n\n.cw-icon-split-screen-expand-left::before {\n  content: @cw-icon-split-screen-expand-left;\n}\n\n.cw-icon-notification-add::before {\n  content: @cw-icon-notification-add;\n}\n\n.cw-icon-previous::before {\n  content: @cw-icon-previous;\n}\n\n.cw-icon-filter-table::before {\n  content: @cw-icon-filter-table;\n}\n\n.cw-icon-agol::before {\n  content: @cw-icon-agol;\n}\n\n","@import \"less/icons.less\";\n\n/* --------------------------------\nFont face definition simplified to only include woff2\n-------------------------------- */\n@font-face {\n  font-family: 'cw-icon';\n  src: url('fonts/cw-icon.woff2') format('woff2');\n  font-weight: normal;\n  font-style: normal;\n}\n",":root {\n    --bgColor_appBar: var(--cw-color-back-primary);\n    --fgColor_spinner: #2e78ac;\n    --height_topAppBar: 60px;\n\n    --cw-color-primary: @col_trimble_blue_light;\n\n    --cw-color-text-primary: @col_trimble_gray;\n    --cw-color-text-secondary: fade(@col_trimble_gray, 70%);\n    --cw-color-text-hint: fade(@col_trimble_gray, 50%);\n\n    --cw-color-back-primary: @col_white;\n    --cw-color-back-blue: @col_blue_pale; // #eaf4fb?\n\n    --cw-color-divider-primary: fade(@col_trimble_gray, 65%);\n    --cw-color-divider-secondary: fade(@col_trimble_gray, 15%);\n\n    --cwui-color-palette-warn: @col_red;\n\n    // bootstrap overrides\n\n    .btn.btn-primary {\n        --bs-btn-color: @col_white;\n        --bs-btn-bg: @col_trimble_blue;\n        --bs-btn-border-color: @col_trimble_blue;\n        --bs-btn-hover-color: @col_white;\n        --bs-btn-hover-bg: #0082d6;\n        --bs-btn-hover-border-color: #0082d6;\n        --bs-btn-focus-shadow-rgb: 49, 132, 253;\n        --bs-btn-active-color: @col_white;\n        --bs-btn-active-bg: #00548a;\n        --bs-btn-active-border-color: #00548a;\n        --bs-btn-disabled-color: @col_white;\n        --bs-btn-disabled-bg: @col_trimble_blue;\n        --bs-btn-disabled-border-color: @col_trimble_blue;\n    }\n\n    .btn.btn-light {\n        --bs-btn-color: @col_trimble_gray;\n    }\n\n    .card {\n        --bs-card-bg: var(--cw-color-back-primary);\n    }\n\n    .navbar {\n        --bs-navbar-padding-x: 16px;\n        --bs-navbar-padding-y: 2.25px;\n    }\n}\n\n// dark theme overrides\n// @media (prefers-color-scheme: dark) {\n//     :root {\n//         --cw-color-back-primary: @col_trimble_gray;\n//         --cw-color-back-blue: @col_blue_dark;\n\n//         --cw-color-divider-primary: @col_white;\n//         --cw-color-divider-secondary: fade(@col_white, 40%);\n\n//         --bs-body-bg: #353a40;\n//         --bs-body-color: @col_white;\n//         --cw-color-text-primary: @col_white;\n//         --cw-color-text-secondary: fade(@col_white, 60%);\n//         --cw-color-text-hint: fade(@col_white, 40%);\n//     }\n// }\n\n// Trimble LESS Color variables\n// V4 - September 2021\n\n//Brand colors\n@col_trimble_blue_dark: #004f83;\n@col_trimble_blue: #0063a3;\n@col_trimble_blue_light: #217cbb;\n@col_trimble_yellow: #fbad26;\n@col_trimble_green: #349c44;\n@col_trimble_red: #b44e2a;\n\n//Grayscale\n@col_white: #fff;\n@col_gray_half: #f9f9fb;\n@col_gray_light: #f1f1f6;\n@col_gray_0: #e0e1e9;\n@col_gray_1: #cbcdd6;\n@col_gray_2: #b7b9c3;\n@col_gray_3: #a3a6b1;\n@col_gray_4: #90939f;\n@col_gray_5: #7d808d;\n@col_gray_6: #6a6e79;\n@col_gray_7: #585c65;\n@col_gray_8: #464b52;\n@col_gray_9: #353a40;\n@col_gray_10: #171c1e;\n@col_trimble_gray: #252a2e;\n@col_black: #000;\n\n//Blue Buttons & Notifications\n@col_blue: #0063a3;\n@col_blue_light: #217cbb;\n@col_blue_dark: #0e416c;\n@col_blue_pale: #dcedf9;\n\n//Green Buttons & Notifications\n@col_green: #1e8a44;\n@col_green_light: #4ea646;\n@col_green_dark: #006638;\n@col_green_pale: #e0eccf;\n\n//Yellow Buttons\n@col_yellow: #fbad26;\n@col_yellow_light: #fec157;\n@col_yellow_dark: #e49325;\n@col_yellow_pale: #fff5e4;\n\n//Red Buttons & Notifications\n@col_red: #da212c;\n@col_red_light: #e86363;\n@col_red_dark: #ab1f26;\n@col_red_pale: #fbd4d7;\n\n//Markup\n@col_markup: #f0f;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
